module.exports = __webpack_public_path__ + "img/1_1-residenziale-villette_singole-1.6471f3f1.png";